module.exports = __webpack_public_path__ + "static/media/Bg-faq-amc.8f5d05f8.svg";